<template>
	<div class="scrollable only-y">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-account-edit widget-icon accent-text fs-30"></i> {{ $t('menu.management_admin') }}</h2>
		</div>
		<el-card>
			<el-dialog title="Detail Account" :visible.sync="dialogFormVisible">
				<el-form :model="detailAdmin" :loading="formLoading">
					<el-form-item label="Username" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="detailAdmin.username" auto-complete="off" :disabled="btnEdit_username"></el-input>
						<div class="btn_edit">
							<el-tooltip content="Edit" placement="top">
								<el-button @click="btnEdit_username = !btnEdit_username" type="primary" size="small">
									<i class="mdi mdi-border-color"></i> 
								</el-button>
							</el-tooltip>
						</div>
					</el-form-item>
					<el-form-item label="Email" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="detailAdmin.email" auto-complete="off" :disabled="btnEdit_email"></el-input>
						<div class="btn_edit">
							<el-tooltip content="Edit" placement="top">
								<el-button @click="btnEdit_email = !btnEdit_email" type="primary" size="small">
									<i class="mdi mdi-border-color"></i> 
								</el-button>
							</el-tooltip>
						</div>
					</el-form-item>
					<el-form-item v-if="btnEdit_password == true" label="Password" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" type="password" v-model="detailAdmin.password" auto-complete="off" :disabled="btnEdit_password"></el-input>
						<div class="btn_edit">
							<el-tooltip content="Edit" placement="top">
								<el-button @click="btnEdit_password = !btnEdit_password" type="primary" size="small">
									<i class="mdi mdi-border-color"></i> 
								</el-button>
							</el-tooltip>
						</div>
					</el-form-item>
					<template v-else>
						<el-form-item label="Current Password" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" type="password" v-model="editAdmin.password" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="New Password" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" type="password" v-model="newpassword" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="Retype Password" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" type="password" v-model="editAdmin.retypepassword" auto-complete="off"></el-input>
						</el-form-item>
					</template>
					<el-form-item label="Created At" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="detailAdmin.created_at" auto-complete="off" :disabled="btnEdit"></el-input>
					</el-form-item>
					<el-form-item label="Updated At" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="detailAdmin.updated_at" auto-complete="off" :disabled="btnEdit"></el-input>
					</el-form-item>
					<el-form-item label="Last Login At" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="detailAdmin.last_login_at" auto-complete="off" :disabled="btnEdit"></el-input>
					</el-form-item>
					<el-form-item label="Role" :label-width="formLabelWidth">
						<el-tag type="success" v-model="detailAdmin.role" disabled>
							<template>
								Super Administrator
							</template>
						</el-tag>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">Cancel</el-button>
					<el-button type="primary" @click="updateAdmin" :loading="btnLoading">Update</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Confirmation" :visible.sync="dialogCheckVisible">
				<el-form :model="confirmation" :loading="formLoading">
					<el-form-item label="Username" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="confirmation.username" auto-complete="off" disabled></el-input>
					</el-form-item>
					<el-form-item label="Password" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" type="password" v-model="confirmation.password" auto-complete="off"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogCheckVisible = false">Cancel</el-button>
					<el-button type="primary" @click="checkAdmin" :loading="btnLoading">Submit</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Add New Admin" :visible.sync="dialogCreateVisible">
				<el-form :model="newAdmin" :loading="formLoading">
					<el-form-item label="Username" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="newAdmin.username" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="Email" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" v-model="newAdmin.email" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="Password" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" type="password" v-model="newAdmin.password" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="Retype Password" :label-width="formLabelWidth">
						<el-input :style="{ width: '80%'}" type="password" v-model="newAdmin.re_password" auto-complete="off"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogCreateVisible = false">Cancel</el-button>
					<el-button type="primary" @click="createAdmin" :loading="btnLoading">Create</el-button>
				</span>
			</el-dialog>
			<div slot="header" class="clearfix">
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
						Admin : <br>
						<span style="font-size:32px;">{{ (total) }}</span>
					</el-card>
					<!-- <el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10" v-else>
						Personal Account : <br>
						<span style="font-size:32px;">{{ (total) }}</span>
					</el-card> -->
				</el-col>
			</div>
			<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
				<el-button type="primary" @click="dialogCreateVisible = true" style="float:left;" class="mt-20 mb-20">+ Add New Admin</el-button>
				<span style="margin-top: 17px; margin-right: 6px; float: right;">
					<el-input
						class="search-customer mb-10 fl-l" style="width:auto;"
						prefix-icon="el-icon-search"
						placeholder="Search Admin Name"
						clearable
						@keypress.native="doSearchAdmin"
						@clear="doSearchAdmin"
						@keyup.native="doSearchAdmin"
						v-model="searchAdmin">
					</el-input>
				</span>
			</el-col>
			<template>
				<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
					<el-pagination
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginateAdmin"
						:current-page="currentPage"
						:total="parseInt(total)">
					</el-pagination>
				</el-col>
				<el-table :data="admin" class="v2-table.styled" style="width: 100%" v-loading="loadingConsumen" element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading">
					<el-table-column prop="customer_name" label="Username" width="200" fixed="left">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{props.row.username}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="created_at" label="Email" width="300">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{props.row.email}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="user" label="Created At" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.created_at, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="user" label="Updated At" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.updated_at, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="user" label="Last Login At" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.last_login_at, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="#" width="150">
						<template slot-scope="scope">
							<el-tooltip content="Detail" placement="top">
								<el-button @click="userId = scope.row.user_id; dialogCheckVisible = true; confirmation.username = scope.row.username" type="info" size="small">
									<i class="mdi mdi-eye"></i> 
								</el-button>
							</el-tooltip>
							<el-tooltip v-if="scope.row.use == true" content="Delete" placement="top">
								<el-button @click="userId = scope.row.user_id; dialogCheckVisible = true; btnType = 1; confirmation.username = scope.row.username" type="danger" size="small" disabled>
									<i class="mdi mdi-delete-forever"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip v-else content="Delete" placement="top">
								<el-button @click="userId = scope.row.user_id; dialogCheckVisible = true; btnType = 1; confirmation.username = scope.row.username" type="danger" size="small">
									<i class="mdi mdi-delete-forever"></i>
								</el-button>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table>
			</template>
		</el-card>
		<el-card class="mt-10">
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateAdmin"
				:current-page="currentPage"
				:total="parseInt(total)">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
const cityOptions = ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen'];
const NodeRSA = require('node-rsa')
const key = new NodeRSA({b:512});
const pub = key.importKey(config.privateKey, 'pkcs1-public-pem');

export default {
	name: 'Consumen',
	data () {
		return {
			searchAdmin:this.$route.query.query || "",
			total:'',
			userId: '',
			admin: [],
			detailAdmin: {},
			btnType: 0,
			btnEdit: true,
			btnEdit_username: true,
			btnEdit_email: true,
			btnEdit_password: true,
			formLoading: false,
			btnLoading: false,
			newpassword: '',
			newAdmin: {
				username: '',
				email: '',
				password: '',
				re_password: ''
			},
			confirmation: {
				username: '',
				password: ''
			},
			editAdmin: {
				password: '',
				newpassword: '',
				retypepassword: ''
			},
			loadingConsumen:true,
			currentPage: parseInt(this.$route.query.page) || 1,
			dialogTableVisible: false,
			dialogFormVisible: false,
			dialogCheckVisible: false,
			dialogCreateVisible: false,
			formLabelWidth: '150px',
			timeout:null
			// totalCount:100000
		}
	},
	methods: {
		validateEmail(mail){
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
			{
				return true
			}
			else{
				return false
			}
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val == null){
				return "-"
			}
			else{
				return moment(val).format(format)
			}
		},
		async paginateAdmin(page){
			this.currentPage = page
			await this.loadAdmin(this.currentPage)
		},
		doSearchAdmin(ev){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.loadAdmin()
			}, 1000)
		},
		async loadAdmin(page = 1){
			this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'admin_credential?page=' + page + '&query=' + this.searchAdmin,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					let admin = response.data.data.admin
					// console.log("dp_user",this.dp_user)
					// let dp_user = []
					admin = _.orderBy(admin, function(o) { return new moment(o.created_at); }, ['desc']);
					this.btnType = 0
					this.admin = admin
					this.total = response.data.data.total
				}
			}).catch(error => {
				// console.log("Error",error)
			})
			this.loadingConsumen = false
		},

		async checkAdmin(){
			this.btnLoading = true
			await api({
				url:config.baseApi+'admin_credential/check/'+ this.userId,
				method:'POST',
				data: {
					username: this.confirmation.username,
					email: this.confirmation.email,
					password: pub.encrypt(this.confirmation.password, 'base64')
				}

			}).then(async response => {
				if(response.data.ec != 200){
					this.dialogCheckVisible = false
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")

				} else {
					this.btnLoading = false
					if(this.btnType == 0){
						this.dialogCheckVisible = false
						await this.detailsAdmin(this.userId)
					}
					else{
						this.$confirm(
							`Are you sure want to delete account <b>${this.confirmation.username}</b> ?`,
							"Confirm",
							{
							confirmButtonText: "Yes",
							cancelButtonText: "No",
							type: "warning",
							center: true,
							dangerouslyUseHTMLString: true
							}
						)
						.then(async () => {
							await api({
								method:'post',
								url: config.baseApi+'admin_credential/delete/'+ this.userId,
								data: {
									password: pub.encrypt(this.confirmation.password, 'base64')
								}
							}).then(async res => {
								// console.log('response add product user',res.data)
								if(res.data.ec != 200){
									this.$swal(this.$t('error'), this.$t('error_text'), "error")
								}
								else{
									await this.loadAdmin()
									this.$swal({
										title: this.$t("success"),
										text: "Update Success",
										type: "success"
									});
								}
							}).catch(err => {
								console.log('error',err.message)
								this.$swal(this.$t('error'), this.$t('error_text'), "error")
							})

							this.dialogCheckVisible = false
						})
						.catch(cancel => {
							this.dialogCheckVisible = false
						})
					}
				}
			}).catch(error => {
				console.log("Error",error)
				this.dialogCheckVisible = false
				this.$swal(this.$t('error'), this.$t('wrong password'), "error")
			})
		},

		async paginateConsumen(page){
			this.currentPage = page
			await this.loadAdmin(this.currentPage)
		},
		async detailsAdmin(param){
			this.dialogFormVisible = true
			this.formLoading = true
			await api({
				method:'get',
				url:config.baseApi+'admin_credential/'+ param,
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else{
					this.detailAdmin = res.data.data
					this.detailAdmin.created_at = this.formatDate(this.detailAdmin.created_at, "DD/MM/YY HH:mm:ss")
					this.detailAdmin.updated_at = this.formatDate(this.detailAdmin.updated_at, "DD/MM/YY HH:mm:ss")
					if(/\d/.test(this.detailAdmin.last_login_at) == true){
						this.detailAdmin.last_login_at = this.formatDate(this.detailAdmin.last_login_at, "DD/MM/YY HH:mm:ss")
					}
					else {
						this.detailAdmin.last_login_at = "-"
					}
					let a = '*';
					let b = ''
					for (let i = 0; i < this.detailAdmin.password; i++) {
						b += a;
					}
					this.detailAdmin.password = b
				}
				this.formLoading = false
			}).catch(err => {
				console.log('error',err.message)
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.formLoading = false
			})
		},

		async createAdmin(){
			let data = {
				username: this.newAdmin.username,
				email: this.newAdmin.email,
				password: pub.encrypt(this.newAdmin.password, 'base64'),
				re_password: pub.encrypt(this.newAdmin.re_password, 'base64')
			}

			if(
			this.newAdmin.username == "" ||
			this.newAdmin.username.trim() == " " ||
			this.newAdmin.email == "" 
			){
				this.$message({
					showClose: true,
					message: "Oops, all field is required",
					type: "error"
				});
				return
			}

			// if(this.validateEmail(this.newAdmin.email) == false){
			// 	this.$message({
			// 		showClose: true,
			// 		message: "Oops, invalid email",
			// 		type: "error"
			// 	});
			// 	return
			// }

			this.btnLoading = true
			await api({
				method:'post',
				url: config.baseApi+'admin_credential/create',
				data: data
			}).then(async res => {
				this.dialogCreateVisible = false
				// console.log('response add product user',res.data)
				this.btnLoading = false
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else{
					this.newAdmin = {}
					this.$swal({
						title: this.$t("success"),
						text: "Update Success",
						type: "success"
					});

					await this.loadAdmin()
				}
			}).catch(err => {
				console.log('error',err.message)
				this.dialogCreateVisible = false
				this.btnLoading = false
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
		},

		async updateAdmin(){
			let data = {
				username: this.detailAdmin.username,
				email: this.detailAdmin.email,
				password: pub.encrypt(this.confirmation.password, 'base64'),
				new_password: pub.encrypt(this.editAdmin.newpassword),
				re_password: pub.encrypt(this.editAdmin.retypepassword)
			}

			if(
			this.detailAdmin.username == "" ||
			this.detailAdmin.username.trim() == " " ||
			this.detailAdmin.email == "" 
			){
				this.$message({
					showClose: true,
					message: "Oops, all field is required",
					type: "error"
				});
				return
			}

			if(this.validateEmail(this.detailAdmin.email) == false){
				this.$message({
					showClose: true,
					message: "Oops, invalid email",
					type: "error"
				});
				return
			}

			if(this.btnEdit_password == false){
				this.editAdmin.newpassword = this.newpassword
				if(
					this.editAdmin.password == "" ||
					this.editAdmin.newpassword == "" ||
					this.editAdmin.retypepassword == ""
				){
					this.$message({
						showClose: true,
						message: "Oops, all field is required",
						type: "error"
					});
					return
				}
				else {
					data.password = pub.encrypt(this.editAdmin.password, 'base64')
					data.new_password = pub.encrypt(this.editAdmin.newpassword, 'base64')
					data.re_password = pub.encrypt(this.editAdmin.retypepassword, 'base64')
				}
			}

			this.btnLoading = true
			await api({
				method:'post',
				url: config.baseApi+'admin_credential/update/'+ this.detailAdmin.user_id,
				data: data
			}).then(res => {
				this.dialogFormVisible = false
				this.btnLoading = false
				// console.log('response add product user',res.data)
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else{
					this.detailAdmin = {}
					this.loadAdmin()
					this.$swal({
						title: this.$t("success"),
						text: "Update Success",
						type: "success"
					});
				}
			}).catch(err => {
				console.log('error',err.message)
				this.dialogFormVisible = false
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
		}

	},
	watch: {
		dialogFormVisible: function(){
			if(this.dialogFormVisible == false){
				this.btnEdit_username = true
				this.btnEdit_password = true
				this.btnEdit_email = true
				this.detailAdmin = {}
				this.editAdmin = {
					password: '',
					newpassword: '',
					retypepassword: ''
				}
			}
		},
		dialogCreateVisible: function(){
			this.btnLoading = false
			if(this.dialogCreateVisible == false){
				this.newAdmin = {
					username: '',
					email: '',
					password: '',
					re_password: ''
				}
			}
		},
		dialogCheckVisible: function(){
			this.btnLoading = false
			if(this.dialogCheckVisible == true){
				this.confirmation.password = ''
			}
		},
		newpassword: function(){
			if(this.newpassword.includes(" ") == true){
				this.$message({
					showClose: true,
					message: "Cannot use space character",
					type: "error"
				});
				this.newpassword = ''
			}
		}

	},
	async mounted(){
		if(this.$route.query.page){
			this.currentPage = parseInt(this.$route.query.page)
		}
		await this.loadAdmin(this.currentPage)
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';
@import '../assets/scss/tables';
@import '../assets/scss/v2-table';
@import '../assets/scss/vue-good-table';

.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
.search-customer {
  width: 100%;
}

.btn_edit {
	margin-left: 10px;
	display: inline-block;
}

</style>
